// extracted by mini-css-extract-plugin
module.exports = {"actions":"Actions_actions__2lFTU","buttons":"Actions_buttons__M0i1o"};